// extracted by mini-css-extract-plugin
export var alternate = "_1f-j";
export var black = "_1f-6";
export var blue = "_1f-f";
export var blueLight = "_1f-e";
export var brand = "_1f-8";
export var darkMode = "_1f-b";
export var error = "_1f-a";
export var gray = "_1f-5";
export var grayBlue = "_1f-d";
export var iconWrapper = "_1f-3";
export var inactive = "_1f-7";
export var indigo = "_1f-g";
export var orange = "_1f-i";
export var pink = "_1f-h";
export var primary = "_1f-0";
export var purple = "_1f-9";
export var success = "_1f-4";
export var warning = "_1f-c";
export var white = "_1f-1";
export var whiteSuccess = "_1f-2";